import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]

  connect() {
    console.log("Uikit Tab controller connected")
    this.initializeTabs()
  }

  initializeTabs() {
    // Set up click handlers for all tab buttons
    this.tabTargets.forEach(tab => {
      tab.addEventListener('click', (e) => {
        e.preventDefault()
        this.switchTab(tab.dataset.tabId)
      })
    })
  }

  switchTab(tabId) {
    console.log(`Switching to tab: ${tabId}`)
    
    // Remove active class from all tabs and panels
    this.tabTargets.forEach(tab => {
      tab.classList.remove('border-primary', 'text-primary')
      tab.classList.add('border-transparent', 'text-neutral-500')
      tab.setAttribute('aria-selected', 'false')
    })

    this.panelTargets.forEach(panel => {
      panel.classList.add('hidden')
      panel.setAttribute('aria-hidden', 'true')
    })

    // Add active class to selected tab and show corresponding panel
    const activeTab = this.tabTargets.find(tab => tab.dataset.tabId === tabId)
    const activePanel = this.panelTargets.find(panel => panel.dataset.tabId === tabId)

    if (activeTab && activePanel) {
      activeTab.classList.remove('border-transparent', 'text-neutral-500')
      activeTab.classList.add('border-primary', 'text-primary')
      activeTab.setAttribute('aria-selected', 'true')
      
      activePanel.classList.remove('hidden')
      activePanel.setAttribute('aria-hidden', 'false')
      
      // Trigger custom event for other controllers to listen to
      this.dispatch('tabChanged', { detail: { tabId: tabId } })
    }
  }
}
